module.exports = __webpack_public_path__ + "static/img/szafa_42.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/szafa_42.jpg
// module id = wd8b
// module chunks = 0